import React, { memo, forwardRef } from "react";
const SvgPositiveIons = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M21.84 9.14v1.72c0 .12-.02.217-.06.29a.524.524 0 01-.13.18.443.443 0 01-.17.08.718.718 0 01-.15.02.718.718 0 01-.15-.02.442.442 0 01-.17-.08.648.648 0 01-.14-.18.707.707 0 01-.05-.29V9.14H19.1a.708.708 0 01-.29-.05.646.646 0 01-.18-.14.44.44 0 01-.08-.17.711.711 0 01-.02-.15c0-.04.007-.09.02-.15a.44.44 0 01.08-.17.52.52 0 01.18-.13c.074-.04.17-.06.29-.06h1.72V6.4c0-.12.017-.217.05-.29a.517.517 0 01.14-.17.384.384 0 01.17-.09c.06-.013.11-.02.15-.02.04 0 .09.007.15.02.06.013.117.043.17.09a.43.43 0 01.13.17c.04.073.06.17.06.29v1.72h1.72c.12 0 .217.02.29.06.074.033.13.077.17.13.047.053.077.11.09.17.014.06.02.11.02.15 0 .04-.006.09-.02.15a.386.386 0 01-.09.17.518.518 0 01-.17.14.709.709 0 01-.29.05h-1.72z"
      />
      <rect width={10} height={14} x={8} y={11.66} fill="#D9D9D9" rx={2} />
    </svg>
  );
});
SvgPositiveIons.displayName = "SvgPositiveIons";
const MemoForwardRef = memo(SvgPositiveIons);
export default MemoForwardRef;
